module.exports = __webpack_public_path__ + "img/solution_communitycare_sys_en.e09ff83b.jpg";